import { useI18n } from "@garther/ui/libs";
import { createFileRoute, useRouteContext } from "@tanstack/react-router";

import { OrgReferral } from "../-components/org-referral";

export const Route = createFileRoute("/_auth/org/$orgId/referrals/")({
  component: RouteComponent
});

function RouteComponent() {
  const { t } = useI18n();
  const { org } = useRouteContext({ from: "/_auth/org/$orgId/referrals/" });

  return (
    <div className="py-4 md:py-6 space-y-4">
      <div>
        <p className="text-responsive-xl font-light text-text-primary uppercase font-literata mb-1">
          {t("org.tabs.wallet")}
        </p>
        <p className="text-responsive-base font-normal text-text-secondary">
          Theo dõi dòng tiền, phí dịch vụ và rút tiền về tài khoản ngân hàng.
        </p>
      </div>
      <OrgReferral org={org} />
    </div>
  );
}
